import React, { Component } from 'react';
import {Field, FieldArray, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormData from 'form-data';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import classes from '../../../utils/cssClasses';
import Loading from '../../Loading';
import Layout from '../Layout/Layout';
import { connect } from 'react-redux';
import * as actions from '../../../actions';

import style from './EditBadgeClass.scss';

import RenderField from '../RenderField';
import FieldDropzone from '../FieldDropzone/FieldDropzone';
import AlignamentRepeater from '../AlignamentRepeater/AlignamentRepeater';
import TagRepeater from '../TagRepeater/TagRepeater';
import AssertionList from '../AssertionList/AssertionList'; 

class EditBadgeClass extends Component{
	constructor(props){
		super(props);

		this.state = {
			formLoading: false,
		}
	}

	componentDidMount() {
		// this.props.fetchIssuer();
		this.props.fetchBadgeClass(this.props.match.params.id);
		
	}

	onSubmit(values) {
		// console.log(values);
		//  THAT Seems sooo wrong :/ 
		var body = new FormData();
		Object.keys(values).forEach(( key ) => {
			// console.log(values[key])
			if ((key === 'image'  || key === 'hero_image') && typeof values[key] === "object" ){
				body.append(key, values[ key ][0],values[ key ][0].fileName);
			}else if (typeof values[key] === "object" ){
				body.append(key, JSON.stringify(values[ key ]));
			}else{
				body.append(key, values[ key ]);
			}
		});
				
		this.props.badgeClass.loading = true;

		this.props.updateBadgeClass(this.props.badgeClass._id, body);

		this.setState({
			...this.state,
			formLoading: true
		})
	}


	render() {
		const { handleSubmit, badgeClass } = this.props;

		if (this.props.badgeClass === null  || this.props.badgeClass._id !==  this.props.match.params.id ) {
			return (
				<Layout>
					<Loading />
				</Layout>
				);
		}else{
			return ( 
				<Layout>
					<header>
						<div className={classes('row align-items-center')}>
							<div className={classes('col-12 col-md')}>
								<h2 className={classes('title-class-badge',style)}>Modifica Badge Class <small><a href="#assegnationList">Assegnation list</a></small></h2> 
								<p><em>I BadgeClass sono gli elementi che andranno assegnati, mediante le assertions, alle persone. </em></p>
							</div>
							<div className={classes('col-12 text-center text-md-right col-md-auto')}>
								<Link to={`/admin/badgeclasses/${badgeClass._id}/assertion`} className={classes('btn btn-primary btn-lg')}>
									Assign Badge
								</Link>
								<br />
								<Link to={`/admin/badgeclasses/${badgeClass._id}/import-assertions`} className={classes('btn mt-2 btn-secondary btn-lg')}>
									Import & assign
								</Link>
							</div>
						</div>
						<div className={classes('row align-items-center')}>
							<div className={classes('col-auto text-center')}>
								<FieldDropzone
									validationTypes={['svg']}
									name="image" />
								<small>L'immagine è obbligatoria e <br/> deve essere svg.</small>
							</div>
							<div className={classes('col')}>
								<Field
									type="text"
									label="Nome BadgeClass"
									name="name"
									className={classes('form-control form-control-lg')}
									component={RenderField}
									required
								/>
								<Field
									type="checkbox"
									label="Test badge"
									id="test"
									name="test"
									component={RenderField} />		        		
		        		<small className={classes('mb-3')}>
		        			Select this if you want to use this badge as test. Notice that in this way the Badge won't be visible on the public site.
		        		</small>
							</div>
						</div>
					</header>
					<form
						onSubmit={handleSubmit(this.onSubmit.bind(this))}>
						<Field
							name="issuer"
							val={this.props.badgeClass.issuer}
							component={({ input, val }) => {
								// console.log(val);
								input.onChange(val);
								return '';
							}} /> 
						<div className={classes('row mt-4')}>
							<div className={classes('col-12 mb-3')}>
								<div className={classes('card')}>
									<div className={classes('card-body')}>
										<h4>Tags</h4>
										{/* <p className={classes('form-text text-muted')} >Lista dei Tag</p> */}
										<FieldArray
											name="tags"
											component={TagRepeater}
											/>
									</div>
								</div>
							</div>
							<div className={classes('col-12 col-md-6')}>
								<Field
									type="textarea"
									required
									label="Descrizione"
									name="description"
									component={RenderField} />
							</div>
							<div className={classes('col-12 col-md-6')}>
								<Field
									type="textarea"
									required
									label="Criteria"
									name="criteria"
									component={RenderField} />
								<p className={classes('small','style')}> <b>Can be written in markdown</b> </p>
							</div>
							<div className={classes('col-12')}>
								<hr/>
								<h4>Alignament</h4>
								<p className={classes('form-text text-muted')} >Lista di dettagli aggiuntivi per la BadgeClass (documenti, uris, specifiche tecniche)</p>
								<FieldArray
									name="alignment"
									component={AlignamentRepeater}
									/>
							</div>
							{/*<div className={classes('col-12 col-md-4')}>
								<h2>Tags</h2>
							</div>*/}
							<div className={classes('col-12')}>
								<FieldDropzone
									style={style}
									name="hero_image" />
							</div>
							<div className={classes('col-12 mt-3')}>
								<button type="submit" className={classes('btn btn-primary btn-lg')} >Salva</button>
								{ this.props.badgeClass.loading ? (
	    							<FontAwesomeIcon icon="spinner" spin  />
									) : ''}
							</div>
						</div>
					</form>

					<div className={classes("mt-5 mb-3 card")} id="assegnationList">
						<div className={classes("card-header")}>
							<b>Assegnation list</b>
						</div>
						<div className={classes("card-body")}>
							<AssertionList 
								badgeClass={badgeClass}
							/>
						</div>
					</div>
				</Layout>
			);
		}
	}
}

function mapStateToProps( { issuer, badgeClass } ){
	// console.log(issuer)
	return {
		badgeClass,
		initialValues: badgeClass
	};
}

function validate(values){
	const errors = {};
	//validate inputs
	const requireds = ["name","image","criteria","description"];
	
	_.forEach(requireds,(key) => {
		if (! values[key]){
			errors[key] = "Mandatory field";
		}
	})

	return errors;
}

export default connect(mapStateToProps,actions)(reduxForm({
	validate,
  enableReinitialize: true, 
	form: 'EditBadgeClass'
})(EditBadgeClass));


// WEBPACK FOOTER //
// ./src/components/Backend/EditBadgeClass/EditBadgeClass.js